
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import DlgEventHostDelete from '@/modules/admin/events/_components/DlgEventHostDelete.vue';
  import Card from '@/components/material/Card.vue';
  import DlgGroupSelector from '@/modules/admin/groups/_components/DlgGroupSelector.vue';
  import DlgHostNew from '@/modules/admin/hosts/_components/DlgHostNew.vue';
  import DlgHostSelector from '@/modules/admin/hosts/_components/DlgHostSelector.vue';
  import DlgEventSendHostEmail from '@/modules/admin/events/_components/DlgEventSendHostEmail.vue';

  @Component({
    components: {DlgEventSendHostEmail, DlgHostSelector, DlgHostNew, DlgGroupSelector, Card, DlgEventHostDelete},
  })
  export default class EventHosts extends Vue {
    public $refs!: {
      form: any,
      dlgGroup: any,
      dlgHosts: any,
    };
    @Prop({type: String, default: ''}) private search!: string;

    @Action('admin/events/readHosts') private readHosts!: (params: any) => Promise<any>;
    @Action('admin/events/addHosts') private addHosts!: (params: any) => Promise<any>;

    @Getter('admin/events/one') private event!: any;
    @Getter('admin/events/hosts') private hosts!: any;

    private hostSearch: string = '';
    private loading: boolean = false;
    private sendHostEmailHost: object = {};
    private sendHostEmailDlg: boolean = false;

    private headers: any = [
      {
        text: 'Email',
        align: 'left',
        sortable: false,
        value: 'email',
      },
      {
        text: 'Vorname',
        value: 'forename',
        align: 'left',
      },
      {
        text: 'Nachname',
        value: 'surname',
        align: 'left',
      },
      {
        text: 'Status',
        value: 'status',
        align: 'left',
      },
      {
        text: 'Email Status',
        value: 'emailStatus',
        align: 'left',
      },
      {
        text: '',
        value: '',
        align: 'left',
      },
    ];

    private async mounted() {
      this.loading = true;
      await this.readHosts({id: this.event.id});
      this.loading = false;
    }

    private async addHost(host) {
      this.loading = true;
      await this.addHosts({id: this.event.id, hosts: [host.id]});
      await this.readHosts({id: this.event.id});
      this.loading = false;
    }

    private async selectedHost(host) {
      this.loading = true;
      await this.addHosts({id: this.event.id, hosts: [host.id]});
      await this.readHosts({id: this.event.id});
      this.$refs.dlgHosts.close();
      this.loading = false;
    }

    private hostSearchChanged(e) {
      this.hostSearch = e;
    }

    private async importGroup(group) {
      this.loading = true;

      const ids: string[] = [];

      group.members.forEach((member) => {
        ids.push(member.id);
      });

      await this.addHosts({id: this.event.id, hosts: ids});
      this.$refs.dlgGroup.close();
      await this.readHosts({id: this.event.id});
      this.loading = false;
    }

    private sendHostMail(host) {
      this.sendHostEmailHost = host;
      this.sendHostEmailDlg = true;
    }
  }
